import React, {createContext, useCallback, useContext, useState, useMemo} from 'react';
import {useFilter} from '@/contexts/FilterContext';
import isFunction from 'lodash/isFunction';
import map from 'lodash/map';

export const createContextList = (usePagination, name, pageConfig, mapData) => {
  const Context = createContext();

  function Provider(props) {
    const {search, filter} = useFilter();
    const [openModal, setOpen] = useState({open: false});

    const onOpenModal = useCallback((payload) => {
      setOpen({open: true, payload});
    }, []);

    const onCancelModal = useCallback(() => {
      setOpen({open: false});
    }, []);

    const {
      page, data: rawData, totalPages, setPage, isFetching, activeKey, setSize
    } = usePagination(search, filter, pageConfig);

    const data = useMemo(() => {
      if(isFunction(mapData)){
        return map(rawData, mapData);
      }
      return rawData;
    }, [rawData]);

    return (
      <Context.Provider value={{
        page, data, totalPages, setPage, isFetching, activeKey, openModal, onOpenModal, onCancelModal, setSize
      }} {...props} />
    );
  }

  function useList() {
    const context = useContext(Context);
    if (context === undefined) {
      throw new Error(`use${name} must be used within a ${name}Provider`);
    }
    const {
      page, data, totalPages, setPage, isFetching, activeKey, openModal, onOpenModal, onCancelModal, setSize
    } = context;

    return {
      page, data, totalPages, setPage, isFetching, activeKey, openModal, onOpenModal, onCancelModal, setSize
    };
  }

  Provider.propTypes = {};


  return {Provider, useList};
};
